"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareMeasure = void 0;
const equal_with_tolerance_1 = require("../equal-with-tolerance/equal-with-tolerance");
const convert_measure_1 = require("../convert-measure/convert-measure");
/**
 * @summary Compares two measures and returns whether one is less than, equal to
 * or greater than the other.
 *
 * Compares two measures. If the left measure is greater, a positive number is
 * returned. If the left measure is smaller, a negative number is returned. If
 * the measures are equal within a tolerance, zero is returned.
 *
 * Note: Do not rely on the return values being -1 or 1, but compare them
 * against 0 instead. The only guarantee is that the return value is negative,
 * zero, or positive.
 *
 * If the measures do not have the same base unit, an error is thrown.
 *
 * @param {NullableMeasure} left
 * @param {NullableMeasure} right
 * @param {number | undefined} [tolerance]
 * @returns [number]
 * @throws {TypeError} The given values have different units.
 *
 * @see equalWithTolerance
 *
 * @example
 * const comparison = compareMeasure(actual, wanted);
 * if (comparison > 0) {
 *   // too high
 * } else if (comparison < 0) {
 *   // too low
 * } else {
 *   // correct
 * }
 */
function compareMeasure(left, right, tolerance) {
    let rightNormalized = right;
    if (left.unit !== rightNormalized.unit) {
        if (!convert_measure_1.convertMeasure.canConvert(rightNormalized, left.unit)) {
            throw new TypeError('Cannot compare incompatible measures.');
        }
        rightNormalized = (0, convert_measure_1.convertMeasure)(rightNormalized, left.unit);
    }
    if ((0, equal_with_tolerance_1.equalWithTolerance)(left.value, rightNormalized.value, tolerance)) {
        return 0;
    }
    if (left.value == null)
        return -1;
    if (rightNormalized.value == null)
        return 1;
    return Math.sign(left.value - rightNormalized.value);
}
exports.compareMeasure = compareMeasure;
